exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text[data-v-716a9b38]{text-align:left;font-size:14px;padding:3px 0}.item[data-v-716a9b38]{margin-bottom:18px}", ""]);

// exports
